// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__Eh1jy","success":"Button_success__3Tldl","error":"Button_error__C41ul","primary":"Button_primary__3DH7S"};